//-------------------------------------------------------------------------------------
//
//	GfxDrawing3D
//
//		
//
//-------------------------------------------------------------------------------------
import { GfxDrawing, GfxPath } from "./GfxDrawing.js";

//------------------------------------------------------------
//
//	GfxPath (object/API)
//
//------------------------------------------------------------
/*-----------------------------------------------*
 * GfxPath: list of operations (move, line, arc, quadbez, close)
 * describing a path
 *
 * [
 *    {op, x, y, p1, p2, p3 }
 *    ...
 * ] 
 *
 * Functions:
 *
 * 
 *-----------------------------------------------*/

function GfxPath3D()
{
	GfxPath.call(this);
}

GfxPath3D.prototype = Object.create(GfxPath.prototype);

Object.defineProperty(GfxPath3D.prototype, 'constructor', {
	value: GfxPath3D,
	enumerable: false,
	write: true });
	
GfxPath3D.prototype.Is2D = function()
{
	return false;
}

GfxPath3D.prototype.Close = function(pt)
{
	let op = {op: GfxPath.Op.CLOSE };
	this.gfxpath.push(op);
}

GfxPath3D.prototype.MoveTo = function(pt)
{
	let op = {op: GfxPath.Op.MOVETO, pt:{x:pt.x, y:pt.y, z:pt.z} };
	this.gfxpath.push(op);
}

GfxPath3D.prototype.LineTo = function(pt)
{
	let op = {op: GfxPath.Op.LINETO, pt:{x:pt.x, y:pt.y, z:pt.z} };
	this.gfxpath.push(op);
}


GfxPath.prototype.Text = function(pt, str)
{
	let op = {op: GfxPath.Op.TEXT, pt:{x:pt.x, y:pt.y, z:pt.z}, str:str };
	this.gfxpath.push(op);
}



//-------------------------------------------------------------------------------------
//	Find Bounds
//-------------------------------------------------------------------------------------
GfxPath3D.prototype.FindBounds = function(bounds = undefined, margin = 0)
{
	for (var i = 0; i < this.gfxpath.length; i++)
	{
		var minx = undefined;
		var miny = undefined;
		var maxx = undefined;
		var maxy = undefined;
		var minz = undefined;
		var maxz = undefined;
		
		let op = this.gfxpath[i];
		
		if (op.op == GfxPath.Op.MOVETO || op.op == GfxPath.Op.LINETO)
		{
			minx = op.pt.x;
			miny = op.pt.y;
			maxx = op.pt.x;
			maxy = op.pt.y;
			minz = op.pt.z;
			maxz = op.pt.z;
		}
		else if (op.op == GfxPath.Op.ARC || op.op == GfxPath.Op.CIRCLE)
		{
			minx = op.pt.x - op.r;
			miny = op.pt.y - op.r;
			minz = op.pt.z - op.r;
			maxx = op.pt.x + op.r;
			maxy = op.pt.y + op.r;
			maxz = op.pt.z + op.r;
		}
		
		// Adjust the min and max of this op by the provided margin
		// (This is used by the caller to take the line width into account for stroked paths)
		minx -= margin;
		miny -= margin;
		minz -= margin;
		maxx += margin;
		maxy += margin;
		maxz += margin;
		
		if (bounds == undefined && minx != undefined)
		{
			bounds = {min:{x:minx, y:miny, z:minz}, max:{x:maxx, y:maxy, z:maxz}}
		}
		else
		{
			if (bounds.min.x > minx)
				bounds.min.x = minx;
				
			if (bounds.min.y > miny)
				bounds.min.y = miny;
				
			if (bounds.min.z > minz)
				bounds.min.z = minz;
				
			if (bounds.max.x < maxx)
				bounds.max.x = maxx;
				
			if (bounds.max.y < maxy)
				bounds.max.y = maxy;
				
			if (bounds.max.z < maxz)
				bounds.max.z = maxz;
		}
	}
	
	return bounds;
}

//-------------------------------------------------------------------------------------
//	Concat
//-------------------------------------------------------------------------------------
GfxPath3D.prototype.Append = function(pathToAppend)
{
	this.gfxpath = this.gfxpath.concat(pathToAppend.gfxpath);
}

//------------------------------------------------------------
//
//	GfxDrawing3D (object/API)
//
//------------------------------------------------------------
//
function GfxDrawing3D()
{
	GfxDrawing.call(this);
}

GfxDrawing3D.prototype = Object.create(GfxDrawing.prototype);

Object.defineProperty(GfxDrawing3D.prototype, 'constructor', {
	value: GfxDrawing3D,
	enumerable: false,
	write: true });



export { GfxPath3D, GfxDrawing3D };
